import "./src/styles/global.css"
import "typeface-cairo"


